(function(window, $, happy) {
	function openModal(e) {
		var href = $(this).attr('href');
		var modal = $(href + 'Modal');

		e.preventDefault();
		modal.modal();

		modal.on('shown.bs.modal', function () {
		  	modal.find('input').eq(0).focus();
		});

		if (modal.prop('id') === "loginModal") {
			modal.on('hidden.bs.modal', function() {
				$('#loginModal h4.register').hide();
				$('#loginModal h4.login').show();
				$('#loginModal #customer-login').show();
				$('#loginModal #customer-register').hide();
			})
		}
	}

	function showPasswordForm(e) {
		e.preventDefault();

		$('#loginModalForm').hide();
		$('#recoverPassword').show();
	}

	function hidePasswordForm(e) {
		e.preventDefault();

		$('#loginModalForm').show();
		$('#recoverPassword').hide();
	}

	function showRegisterForm(e) {
		$('#loginModal h4.register').show();
		$('#loginModal h4.login').hide();

		$('#loginModal #customer-login').hide();
		$('#loginModal #customer-register').show();
	}

	function closeModals(e) {
		if (e.keyCode === 27) {
			$('.modal').modal('hide');
		}
	}

	function validateForms() {
		$('#subscribeForm').isHappy({
          fields: {
            '#subscribeEmail': {
              required: true,
              message: 'Please enter a valid email. For example johndoe@domain.com.',
              test: happy.email
            }
          }
        });

        $('#contactForm').isHappy({
          fields: {
            '#contactName': {
              required: true,
              message: 'This is a required field.'
            },
            '#contactEmail': {
              required: true,
              message: 'Please enter a valid email address. For example johndoe@domain.com.',
              test: happy.email
            },
            '#contactText': {
              required: true,
              message: 'This is a required field.'
            }
          }
        });

        $('#sizeRequestForm').isHappy({
          fields: {
            '#sizeRequestName': {
              required: true,
              message: 'This is a required field.',
              when: 'blur'
            },
            '#sizeRequestEmail': {
              required: true,
              message: 'Please enter a valid email address. For example johndoe@domain.com.',
              test: happy.email
            },
            '#checkboxValidate': {
            	message: 'Please select a size.',
            	required: true,
            	test: function() {
            		return $('.size-container input:checked').length;
            	}
            }
          },
          when: 'blur'
        });
	}

	function submitContactForm(e) {
		if ($('#contactForm .unhappy').length > 0) {
			return;
		}

		e.preventDefault();

		var action  = '/contact?';
		    action += encodeURIComponent('form_type') +'='+ encodeURIComponent('contact');
		    action += '&'+ encodeURIComponent('utf8') +'='+ encodeURIComponent('✓');
		    action += '&'+ encodeURIComponent('contact[name]') +'='+ encodeURIComponent($('#contactName').val());
		    action += '&'+ encodeURIComponent('contact[email]') +'='+ encodeURIComponent($('#contactEmail').val());
		    action += '&'+ encodeURIComponent('contact[phone]') +'='+ encodeURIComponent($('#contactPhone').val());
		    action += '&'+ encodeURIComponent('contact[body]') +'='+ encodeURIComponent($('#contactText').val());

		$.ajax({
		    type: "POST",
		    url: action
		})
		.done(function() {
			$('#contactModal').modal('hide');
		})
		.fail(function() {
			// something
		})
	}

	function submitNewsletterForm(e) {
		if ($('#subscribeForm .unhappy').length > 0) {
			return;
		}

		e.preventDefault();

		var action  = '/contact?';
		    action += encodeURIComponent('form_type') +'='+ encodeURIComponent('customer');
		    action += '&'+ encodeURIComponent('utf8') +'='+ encodeURIComponent('✓');
		    action += '&'+ encodeURIComponent('contact[name]') +'='+ encodeURIComponent($('#subscribeName').val());
		    action += '&'+ encodeURIComponent('contact[email]') +'='+ encodeURIComponent($('#subscribeEmail').val());
		    action += '&'+ encodeURIComponent('contact[zip]') +'='+ encodeURIComponent($('#subscribeZip').val());
		    action += '&'+ encodeURIComponent('contact[birthday]') +'='+ encodeURIComponent($('#subscribeBirthday').val());
		    action += '&'+ encodeURIComponent('contact[tags]') +'='+ encodeURIComponent('newslettter');

		$.ajax({
		    type: "POST",
		    url: action
		})
		.done(function() {
			$('#subscribeModal').modal('hide');
		})
		.fail(function() {
			// something
		})
	}

	function submitSizeRequest(e) {
		if ($('#sizeRequestForm .unhappy').length > 0) {
			return;
		}

		e.preventDefault();

		var productName = $('.product-info-content h1').text();
		var sizes = '';

		$('#sizeRequestForm li input:checked').each(function(i, item) {
			sizes += $(item).val() + ' ';
		});

		var action  = '/contact?';
		    action += encodeURIComponent('form_type') +'='+ encodeURIComponent('contact');
		    action += '&'+ encodeURIComponent('utf8') +'='+ encodeURIComponent('✓');
		    action += '&'+ encodeURIComponent('contact[name]') +'='+ encodeURIComponent($('#sizeRequestName').val());
		    action += '&'+ encodeURIComponent('contact[email]') +'='+ encodeURIComponent($('#sizeRequestEmail').val());
		    action += '&'+ encodeURIComponent('contact[body]') +'='+ encodeURIComponent('Size Request' + ' ' + productName + ' ' + sizes);

		$.ajax({
		    type: "POST",
		    url: action
		})
		.done(function() {
			$('#sizeRequestModal').modal('hide');
		})
		.fail(function() {
			// something
		})
	}

	function init() {
		$('a[href="#subscribe"]').click(openModal);
		$('a[href="#contact"]').click(openModal);
		$('a[href="#sizeChart"]').click(openModal);
		$('a[href="#sizeRequest"]').click(openModal);
		$('a[href="#login"]').click(openModal);
		$('a[href="#search"]').click(openModal);
		$('a[href="#shipping"]').click(openModal);
		$('#loginModal .forgot-password').click(showPasswordForm);
		$('#loginModal #recoverPassword .note').click(hidePasswordForm);
		$('#loginModal a.create-account').click(showRegisterForm);

		$(document).on('keyup').on('keyup', closeModals);

		validateForms();

		$('#contactForm').on('submit', submitContactForm);
		$('#subscribeForm').on('submit', submitNewsletterForm);
		$('#sizeRequestForm').on('submit', submitSizeRequest);
	}

	$(document).ready(function() {
		init();
	});


}(this, jQuery, happy))